import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetMunicipalities_municipalityId = z.any()
export type TagsGetMunicipalities_municipalityId = z.infer<typeof tagsGetMunicipalities_municipalityId>

export const paramsGetMunicipalities_municipalityId = z.object({ "municipalityId": z.string() })
export type ParamsGetMunicipalities_municipalityId = z.infer<typeof paramsGetMunicipalities_municipalityId>

export const responseGetMunicipalities_municipalityId = z.object({ "payload": z.object({ "id": z.string(), "name": z.string(), "ico": z.string(), "plan": z.enum(["TRIAL","STANDARD","VIP"]).default("TRIAL"), "planStartedAt": z.string(), "planEndsAt": z.string(), "isSMSCrMember": z.boolean().optional(), "smsCrServicesGDPRSale": z.boolean().optional(), "createdAt": z.string().optional(), "updatedAt": z.string().optional(), "image": z.string().optional() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetMunicipalities_municipalityId = z.infer<typeof responseGetMunicipalities_municipalityId>

interface IGetMunicipalities_municipalityId extends BaseMethodType {
  tags: TagsGetMunicipalities_municipalityId,
  params: ParamsGetMunicipalities_municipalityId,
  response: ResponseGetMunicipalities_municipalityId
}
export const tagsPatchMunicipalities_municipalityId = z.any()
export type TagsPatchMunicipalities_municipalityId = z.infer<typeof tagsPatchMunicipalities_municipalityId>

export const paramsPatchMunicipalities_municipalityId = z.object({ "municipalityId": z.string() })
export type ParamsPatchMunicipalities_municipalityId = z.infer<typeof paramsPatchMunicipalities_municipalityId>

export const bodyPatchMunicipalities_municipalityId = z.object({ "name": z.string().optional(), "ico": z.string().optional() })
export type BodyPatchMunicipalities_municipalityId = z.infer<typeof bodyPatchMunicipalities_municipalityId>

export const responsePatchMunicipalities_municipalityId = z.object({ "payload": z.object({ "id": z.string(), "name": z.string(), "ico": z.string() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePatchMunicipalities_municipalityId = z.infer<typeof responsePatchMunicipalities_municipalityId>

interface IPatchMunicipalities_municipalityId extends BaseMethodType {
  tags: TagsPatchMunicipalities_municipalityId,
  params: ParamsPatchMunicipalities_municipalityId,
  body: BodyPatchMunicipalities_municipalityId,
  response: ResponsePatchMunicipalities_municipalityId
}
export const tagsDeleteMunicipalities_municipalityId = z.any()
export type TagsDeleteMunicipalities_municipalityId = z.infer<typeof tagsDeleteMunicipalities_municipalityId>

export const paramsDeleteMunicipalities_municipalityId = z.object({ "municipalityId": z.string() })
export type ParamsDeleteMunicipalities_municipalityId = z.infer<typeof paramsDeleteMunicipalities_municipalityId>

export const responseDeleteMunicipalities_municipalityId = z.any()
export type ResponseDeleteMunicipalities_municipalityId = z.infer<typeof responseDeleteMunicipalities_municipalityId>

interface IDeleteMunicipalities_municipalityId extends BaseMethodType {
  tags: TagsDeleteMunicipalities_municipalityId,
  params: ParamsDeleteMunicipalities_municipalityId,
  response: ResponseDeleteMunicipalities_municipalityId
}
export const URL = '/municipalities/:municipalityId'
export const validation = {
  get: {
    tags: tagsGetMunicipalities_municipalityId,
    params: paramsGetMunicipalities_municipalityId,
    response: responseGetMunicipalities_municipalityId
  },
  patch: {
    tags: tagsPatchMunicipalities_municipalityId,
    params: paramsPatchMunicipalities_municipalityId,
    body: bodyPatchMunicipalities_municipalityId,
    response: responsePatchMunicipalities_municipalityId
  },
  delete: {
    tags: tagsDeleteMunicipalities_municipalityId,
    params: paramsDeleteMunicipalities_municipalityId,
    response: responseDeleteMunicipalities_municipalityId
  }
}
export interface Municipalities_municipalityId extends BaseRouteType {
  get: IGetMunicipalities_municipalityId,
  patch: IPatchMunicipalities_municipalityId,
  delete: IDeleteMunicipalities_municipalityId
}